import React from "react";
import { IndeterminateCheckboxConfig } from "../types";
import CheckboxStateEnum from "shared/enums/CheckboxStateEnum";
import classNames from "classnames";

function IndeterminateCheckbox(props: IndeterminateCheckboxConfig) {
  const handleCheckBox = React.useCallback(() => {
    if (!props.disabled) {
      const checked = props.state === CheckboxStateEnum.CHECKED ? false : true;
      props.handleChange(checked);
    }
  }, [props]);

  return (
    <div
      onClick={handleCheckBox}
      className={classNames("indeterminate_wrapper", {
        disabled: props.disabled
      })}>
      {props.state === CheckboxStateEnum.UNCHECKED && <span className="checkbox_icon unchecked_checkbox"></span>}
      {props.state === CheckboxStateEnum.INDETERMINATE && (
        <span className="checkbox_icon indeterminate_checkbox"></span>
      )}
      {props.state === CheckboxStateEnum.CHECKED && <span className="checkbox_icon checkbox_checked"></span>}
      {props.label}
    </div>
  );
}

export default IndeterminateCheckbox;
